export default __webpack_public_path__ + "static/media/image-homepage-hero@2x.0d83d4b9.jpg";